import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.98 2.196a1 1 0 0 0-1.71-.879l-5.738 6.138a1 1 0 0 0 1.461 1.365l3.337-3.57-1.31 6.554a1 1 0 0 0 .629 1.132l6.6 2.475-1.768 1.894a1 1 0 1 0 1.463 1.365l2.787-2.988a1 1 0 0 0-.38-1.618l-7.204-2.702z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.327 4.26a1 1 0 0 1 1.413.067l5.485 6.034q.042.041.08.087l14.435 15.88a1 1 0 1 1-1.48 1.345L20.466 22.4l-7.735 8.283a1 1 0 0 1-1.712-.879l1.834-9.166-7.204-2.702a1 1 0 0 1-.38-1.618l4.896-5.25L5.26 5.673a1 1 0 0 1 .067-1.413M7.751 16.59l3.763-4.036 7.602 8.362-5.445 5.831 1.31-6.55a1 1 0 0 0-.63-1.132z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLightningSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLightningSlash);
export default Memo;
